import { QueryKey } from "@tanstack/react-query"

const EQueryKey: { Participants(): QueryKey } = {
    Participants: (): QueryKey => ["Assistant", "Participants"]
} as const

const EQueryUrl: { Participants(): string } = {
    Participants: (): string => "/api/ea/participants/"
} as const

export { EQueryKey as EAssistantParticipantsQueryKey, EQueryUrl as EAssistantParticipantsQueryUrl }
